import React from 'react';
import { Box, Pagination } from '@mui/material';
import { dataFormStyles } from '~/modules/covenants/CovenantsDataForm/styles.ts';
import type { TApiReadyCovenant, TApiReadyCovenantDocument } from '~/modules/covenants/types.ts';
import { getReadyCovenantKey } from '../../utils/utils.ts';
import { ReadyCovenantItem } from './ReadyCovenantItem.tsx';

interface IManagerReadyCovenantsListProps {
  covenants: TApiReadyCovenant[];
  page: number;
  pageSize: number;
  totalPages: number;
  expandedCovenantIndex: number | null;
  copiedCovenantKey: string | null;
  documentsByCovenantKey: Record<string, TApiReadyCovenantDocument[]>;
  allDocumentsByCovenantKey: Record<string, TApiReadyCovenantDocument[]>;
  documentsLoadingByCovenantKey: Record<string, boolean>;
  documentsErrorByCovenantKey: Record<string, string>;
  onToggleCovenant: (index: number) => void;
  onCopyMonitoringId: (covenantKey: string, grafId: number) => void | Promise<void>;
  onLoadDocuments: (covenant: TApiReadyCovenant) => void | Promise<void>;
  onPageChange: (page: number) => void;
}

export const ReadyCovenantsList: React.FC<IManagerReadyCovenantsListProps> = ({
  covenants,
  page,
  pageSize,
  totalPages,
  expandedCovenantIndex,
  copiedCovenantKey,
  documentsByCovenantKey,
  allDocumentsByCovenantKey,
  documentsLoadingByCovenantKey,
  documentsErrorByCovenantKey,
  onToggleCovenant,
  onCopyMonitoringId,
  onLoadDocuments,
  onPageChange,
}) => (
  <>
    {covenants.map((covenant, index) => {
      const covenantKey = getReadyCovenantKey(covenant);
      const globalIndex = page * pageSize + index;
      const loadedDocuments = documentsByCovenantKey[covenantKey] ?? [];
      const allDocuments = allDocumentsByCovenantKey[covenantKey] ?? [];
      const totalDocumentIds = Math.max(covenant.documentIdsGroup?.length ?? 0, allDocuments.length);

      return (
        <ReadyCovenantItem
          key={`${covenant.grafId}-${globalIndex}`}
          covenant={covenant}
          globalIndex={globalIndex}
          covenantKey={covenantKey}
          isExpanded={expandedCovenantIndex === globalIndex}
          copiedCovenantKey={copiedCovenantKey}
          loadedDocuments={loadedDocuments}
          loadedCount={loadedDocuments.length}
          totalDocumentIds={totalDocumentIds}
          isDocumentsLoading={Boolean(documentsLoadingByCovenantKey[covenantKey])}
          documentsErrorText={documentsErrorByCovenantKey[covenantKey]}
          onToggleCovenant={onToggleCovenant}
          onCopyMonitoringId={onCopyMonitoringId}
          onLoadDocuments={onLoadDocuments}
        />
      );
    })}

    {totalPages > 1 && (
      <Box sx={dataFormStyles.dialogPagination}>
        <Pagination
          count={totalPages}
          page={page + 1}
          color="primary"
          onChange={(_, value) => {
            onPageChange(value - 1);
          }}
        />
      </Box>
    )}
  </>
);

